document.addEventListener("DOMContentLoaded", function() {
  // Select metafield container
  const metafieldContainer = document.querySelector(".custom-metafield-varaint");
  // Select Shopify variant wrapper
  const variantWrapper = document.querySelector(".product-block .variant-wrapper.js:nth-child(2)");

  // Safety check
  if (!variantWrapper) return;

  // Function to check metafield content
  function updateVariantVisibility() {
    if (metafieldContainer) {
      const hasImage = metafieldContainer.querySelectorAll("img").length > 0;
      if (hasImage) {
        variantWrapper.style.display = "none";
      } else {
        variantWrapper.style.display = "block";
      }
    } else {
      variantWrapper.style.display = "block";
    }
  }

  // Run on page load
  updateVariantVisibility();

  // In case metafield loads later (AJAX themes)
  let tries = 0;
  const interval = setInterval(() => {
    updateVariantVisibility();
    tries++;
    if (tries > 20) clearInterval(interval); // stop after ~2 seconds
  }, 100);
});
